module.exports = __webpack_public_path__ + "44a14acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/icon_longergood_inactive.png
// module id = 1603
// module chunks = 0